import API from "../config/api.js";

export const StockAdjustmentService = {
  getProducts(search = "") {
    return API.get(`api/products/list/se=${search}`);
  },
  getBatches(product_id) {
    return API.get(`/api/stock-adjustments/by-product/${product_id}`);
  },
  getStock(product_id, batch_id) {
    return API.get(`/api/stocks/by-product-batch`, {
      params: { product_id, batch_id },
    });
  },
  createAdjustment(formData) {
    return API.post("/api/stock-adjustments/create", formData);
  },
  createAdjustmentAdd(formData) {
    return API.post("/api/stock-adjustments/createAdd", formData);
  },
};
